import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';

const ServiceImage = ({
  testID,
  turkuPmc,
  showGrayedOutIcon,
}: {
  testID?: string;
  turkuPmc: boolean;
  showGrayedOutIcon?: boolean;
}) => {
  const color = () => {
    if (showGrayedOutIcon) {
      return theme.colors.gray300;
    }
    return !turkuPmc ? theme.colors.black : theme.colors.white;
  };
  return (
    <Icon
      name={
        !turkuPmc && !showGrayedOutIcon ? 'Service-Filled' : 'Services-Outlined'
      }
      color={color()}
      size="l"
      testID={testID}
    />
  );
};

export default ServiceImage;
